import { TeacherContext } from "./_context";

export const TeacherProvider = TeacherContext.Provider